export default __webpack_public_path__ + "static/media/moneyin.bd1d43b9.svg";